<template>
  <div class="container">
    <el-tree
      node-key="id"
      :load="loadLayoutNode"
      lazy
      default-expand-all
      :check-on-click-node="true"
      :props="defaultProps"
      :allow-drop="allowDrop"
      :expand-on-click-node="false"
      :allow-drag="allowDrag"
      @node-click="nodeChange"
    >
      <span class="custom-tree-node" slot-scope="{ node, data }">
        <span v-if="!data.rename" @dblclick="data.rename = true">{{
          data.alias || node.label
        }}</span>
        <span v-else="data.rename"
          ><el-input
            v-model="data.alias"
            size="mini"
            @change="() => rename(data)"
            placeholder="请输入内容"
          ></el-input
        ></span>
        <span>
          <el-button
            type="text"
            size="mini"
            style="margin-right: 10px;"
            v-if="data.events && data.events.length>0"
          >
            <i class="zt icon-tuodong" title="已添加了事件" v-if="data.events"></i>
          </el-button>

          <el-popover placement="top" width="160" :value="showPop(data.id)">
            <p>确定删除吗？</p>
            <div style="text-align: right; margin: 0">
              <el-button
                size="mini"
                type="text"
                @click="visibleRemoveNode = null"
                >取消</el-button
              >
              <el-button
                type="primary"
                size="mini"
                @click="removeNode(node, data)"
                >确定</el-button
              >
            </div>
            <el-button
              slot="reference"
              type="text"
              size="mini"
              style="margin-right: 10px"
            >
              <i class="el-icon-delete" title="删除"></i>
            </el-button>
          </el-popover>

          <el-button
            type="text"
            size="mini"
            @click="() => visibleNode(data, node)"
            :style="{
              color:
                data.visible === true ||
                data.visible == undefined ||
                data.visible == null
                  ? ''
                  : '#cc6565',
            }"
          >
            <i
              v-if="
                data.visible === true ||
                data.visible == undefined ||
                data.visible == null
              "
              class="zt icon-xianshikejian"
              title="显示"
            ></i>
            <i v-else class="zt icon-yincangbukejian" title="隐藏"></i>
          </el-button>
          <el-button
            type="text"
            size="mini"
            @click="() => lockNode(data)"
            :style="{ color: data.locked == 10 ? '#000000' : '',background:data.locked == 10 ? '#cc6565' : ''}"
          >
            <i
              class="zt icon-suoding"
              v-if="data.locked == 10"
              title="锁定"
            ></i>
            <i class="zt icon-jiesuo" v-else title="解锁"></i>
          </el-button>
        </span>
      </span>
    </el-tree>
  </div>
</template>
<script>
export default {
  data() {
    return {
      data: [],
      visibleRemoveNode: 0,
      defaultProps: {
        children: "child",
        label: "label",
      },
    };
  },
  created() {
    this.topo = this.$Core.getProvider("TechnologyTopo");
  },
  methods: {
    showPop(id) {
      return this.visibleRemoveNode == id;
    },
    rename(data) {
      data.rename
        ? this.$set(data, "rename", false)
        : this.$set(data, "rename", true);
      // this.topo.stageCanvas.setValue({ id: data.id, visible: data.visible });
    },
    // 点击节点
    clickNode(e) {
      this.topo.stageCanvas.active([e]);
    },
    // 加载结构列表
    loadLayoutNode(node, resolve) {
      let pens = this.topo.store.data.pens;
      if (node.level === 0) {
        let data = [];
        pens.forEach((item) => {
          item.label = item.alias || item.name;
          item.rename = false;
          if (!item.parentId) {
            data.push(item);
          }
        });
        return resolve(data);
      }

      if (!node.data.children || node.data.children.length === 0)
        return resolve([]);

      let hasChild = false;
      if (node.data.children.length) {
        hasChild = true;
      }
      let data1 = [];
      if (hasChild) {
        node.data.children.forEach((id) => {
          for (let i = 0, len = pens.length; i < len; i++) {
            if (id == pens[i].id) {
              pens[i].label = pens[i].alias || pens[i].name;
              data1.push(pens[i]);
            }
          }
        });
      }

      resolve(data1);
    },
    // 删除节点
    removeNode(node, data) {
      const parent = node.parent;
      this.visibleRemoveNode = data.id;
      // let pens = this.topo.store.data.pens;
      const children = parent.childNodes || parent.data;
      const index = children.findIndex((d) => d.data.id === data.id);
      let pen = this.topo.stageCanvas.find(data.id);
     
      // pen.forEach((item) => {
      //   item.children?.forEach((id) => {
      //     pen = [...pen, ...pens.filter((i) => i.id == id)];
      //   });
      // });
      // console.log(pen)
      
      children.splice(index, 1);
      this.topo.stageCanvas.delete(pen);
      this.topo.stageCanvas.inactive();
      this.topo.stageCanvas.render();

      this.$forceUpdate()
    },
    nodeChange(data) {
      this.topo.stageCanvas.active([data]);
      this.topo.stageCanvas.gotoView(data);
    },
    // 显示节点
    visibleNode(data, node) {
      data.visible
        ? this.$set(data, "visible", false)
        : this.$set(data, "visible", true);
      this.setPensVisible(data);
      this.topo.stageCanvas.setValue({ id: data.id, visible: data.visible });
    },
    //锁定节点
    lockNode(data) {
      data.locked == 10
        ? this.$set(data, "locked", 0)
        : this.$set(data, "locked", 10);
      this.setPensVisible(data);
      this.topo.stageCanvas.setValue({ id: data.id, locked: data.locked });
    },
    //设置子节点的属性
    setPensVisible(data) {
      if (data.children && data.children.length) {
        let pens = this.topo.store.data.pens;
        pens.forEach((item) => {
          data.children.forEach((id) => {
            if (item.id === id) {
              item.visible = data.visible;
              item.locked = data.locked;
            }
          });
        });
      }
    },

    // 拖拽成功
    handleDrop(draggingNode, dropNode, dropType, ev) {
      this.topo.stageCanvas.setValue(this.data);
    },
    allowDrop(draggingNode, dropNode, type) {
      if (dropNode.data.label === "二级 3-1") {
        return type !== "inner";
      } else {
        return true;
      }
    },
    allowDrag(draggingNode) {
      return draggingNode.data.label.indexOf("三级 3-2-2") === -1;
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  .custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 8px;
    &:hover {
      background-color: #0000001e;
      border-radius: 5px;
    }
  }
}
</style>